import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "d-flex flex-column h-100 rounded-4 box-product bg-white mb-4 position-relative"
};
var _hoisted_2 = {
  "class": "d-flex align-items-center"
};
var _hoisted_3 = {
  "class": "flex-shrink-0"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "flex-grow-1 ms-3"
};
var _hoisted_6 = {
  "class": "font-size-md-18"
};
var _hoisted_7 = ["href"];
var _hoisted_8 = {
  "class": "mt-auto border-top pt-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $options.imageSrc,
    "class": "img-fluid img-product"
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("h5", _hoisted_6, [_createElementVNode("a", {
    href: '/directory-demo/search?query=' + $options.query,
    "class": "stretched-link sh-text-black link-hover-blue text-decoration-none"
  }, _toDisplayString($options.text), 9, _hoisted_7)])])]), _createElementVNode("div", _hoisted_8, _toDisplayString($options.totalSuppliers) + " Suppliers selling “" + _toDisplayString($options.text) + "” ", 1)]);
}